module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_9016.d49ea499.png";